// Danh mục vùng trong HANA Hub (QĐ 25/Oct 22:46: một bản dựng Hub, vùng ở /ezy /box /mee /edu /mov; Hei dựng riêng ở /hei/).
// Thứ tự và mô tả theo MAPPS của board Mint-Hub.

export type AppKey = 'hub' | 'ezy' | 'box' | 'hei' | 'mee' | 'edu' | 'mov' | 'kit' | 'ask';

export interface HanaApp {
  key: Exclude<AppKey, 'hub' | 'ask'>;
  name: string;
  short: string;
  desc: string;
  path: string;
  keywords: string;
}

export const APPS: readonly HanaApp[] = [
  { key: 'ezy', name: 'HANA Ezy', short: 'Ezy', desc: 'Job, booking, chứng từ, vận tải', path: '/ezy/', keywords: 'ezy easy logi erp job booking' },
  { key: 'box', name: 'HANA Box', short: 'Box', desc: 'Mail', path: '/box/', keywords: 'box mail thu email outlook inbox' },
  { key: 'hei', name: 'HANA Hei', short: 'Hei', desc: 'Chat nội bộ và Zalo OA', path: '/hei/', keywords: 'hei hey hay chat nhan tin tin nhan zalo whatsapp nhom goi' },
  { key: 'mee', name: 'HANA Mee', short: 'Mee', desc: 'Lương, phép, chấm công của tôi', path: '/mee/', keywords: 'mee me luong phep cham cong don' },
  { key: 'edu', name: 'HANA Edu', short: 'Edu', desc: 'Đào tạo và SOP', path: '/edu/', keywords: 'edu dao tao training sop hoc' },
  { key: 'mov', name: 'HANA Mov', short: 'Mov', desc: 'App tài xế', path: '/mov/', keywords: 'mov move tai xe chuyen xe' },
];

/** Vùng chỉ ghế ADMIN thấy (MAPPS.adm của canvas, QĐ anh David 01/Nov 09:49): HANA Kit /kit — quản trị hệ thống, thuộc PWA Hub. */
export const ADMIN_APPS: readonly HanaApp[] = [
  { key: 'kit', name: 'HANA Kit', short: 'Kit', desc: 'Quản trị hệ thống · chỉ ADMIN', path: '/kit/', keywords: 'kit quan tri admin cai dat he thong' },
];

/** Lưới ▦: ghế thường thấy 6 vùng; ghế ADMIN thêm ADMIN_APPS (mintApps(…, { admin: true })). */
export const appsFor = (admin: boolean): readonly HanaApp[] => (admin ? [...APPS, ...ADMIN_APPS] : APPS);

/** Bỏ dấu tiếng Việt, chữ thường — để tìm "Hey" vẫn ra Hei, "luong" ra Mee. */
export const normalize = (s: string): string =>
  s.toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, '').replace(/đ/g, 'd').trim();

export function searchApps(q: string, list: readonly HanaApp[] = APPS): HanaApp[] {
  const n = normalize(q);
  if (!n) return [...list];
  return list.filter((a) => normalize(`${a.name} ${a.desc} ${a.keywords}`).includes(n));
}
